import styled from "styled-components";

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
`;
